import React from 'react';
import { motion } from 'framer-motion';
import { COLORS } from '../constants';

const SectionHeading = ({ title, subtitle }) => (
  <div className="text-center mb-16 px-4 pt-10">
    <motion.h2 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="text-4xl md:text-5xl font-bold mb-4 font-serif"
      style={{ color: COLORS.secondaryBg }}
    >
      {title}
    </motion.h2>
    <motion.div 
  	initial={{ width: 0 }}
  	whileInView={{ width: "180px" }}
  	viewport={{ once: true }}
  	transition={{ duration: 0.8, ease: "easeOut" }}
 	 className="h-1 mx-auto mb-6 rounded-full"
 	 style={{ 
    	background: `linear-gradient(90deg, transparent, ${COLORS.accent}, transparent)`
	  }}
	/>
    {subtitle && (
      <motion.p 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="text-xl opacity-80 max-w-2xl mx-auto"
        style={{ color: COLORS.textPrimary }}
      >
        {subtitle}
      </motion.p>
    )}
  </div>
);

export default SectionHeading;